module.exports = __webpack_public_path__ + "static/media/book9.d074abbf.jpg";